import React from "react";
import AuditTable from "../audit/AuditAllTabs";

export default function Audit({
  setOpenModalToCreateJobBatches,
  openModalToCreateJobBatches,
}) {
  return (
    <div>
      <AuditTable
        setOpenModalToCreateJobBatches={setOpenModalToCreateJobBatches}
        openModalToCreateJobBatches={openModalToCreateJobBatches}
      />
    </div>
  );
}
